import {
    FindPeopleRequest,
    IndexedPageView,
    PersonaResponseShape,
    FindPeopleJsonResponse,
    getEagerService,
} from '../../../service';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

import {
    HubPersona,
    runOwsRequestWithMonitor,
    createHubPersona,
    Feature,
    fullResponseOperationOption,
} from '../../../shared';

const service = getEagerService();

function createRequest(
    folderIdString: string,
    startIndex: number,
    amount: number
): FindPeopleRequest {
    const defaultPageView: IndexedPageView = {
        BasePoint: 'Beginning',
        Offset: startIndex,
        MaxEntriesReturned: amount,
    };

    const defaultShape: PersonaResponseShape = {
        BaseShape: 'Default',
        AdditionalProperties: [
            service.Factory.propertyUri({ FieldURI: 'PersonaAttributions' }),
            service.Factory.propertyUri({ FieldURI: 'PersonaTitle' }),
            service.Factory.propertyUri({ FieldURI: 'PersonaOfficeLocations' }),
        ],
    };

    return {
        IndexedPageItemView: service.Factory.indexedPageView(defaultPageView),
        QueryString: null,
        ParentFolderId: service.Factory.targetFolderId({
            BaseFolderId: service.Factory.addressListId({ Id: folderIdString }),
        }),
        PersonaShape: service.Factory.personaResponseShape(defaultShape),
        ShouldResolveOneOffEmailAddress: false,
        SearchPeopleSuggestionIndex: false,
    };
}

export default function findPeopleInSparseFolder(
    folderId: string,
    offset: number,
    limit: number
): Promise<{ offset: number; totalCount: number; personas: HubPersona[] }> {
    return runOwsRequestWithMonitor({
        scenarioName: 'FindPeopleInSparseFolder',
        feature: Feature.ContactManagement,
        operation: () =>
            service.Operation.findPeopleOperation(
                service.Factory.findPeopleJsonRequest({
                    Header: getJsonRequestHeader(),
                    Body: createRequest(folderId, offset, limit),
                }),
                fullResponseOperationOption
            ),
        transformResponse: (owsResponse: FindPeopleJsonResponse) => {
            return {
                offset: offset,
                totalCount: owsResponse.Body.TotalNumberOfPeopleInView,
                personas: owsResponse.Body.ResultSet.map(createHubPersona),
            };
        },
    });
}
